import PageComponent from '../../base/PageComponent';
import "bootstrap-3-typeahead";

/**
 * A component for managing the patient fields in a form, looks up the patient using their NHI
 */
export default class PatientFields extends PageComponent
{
    init() {
        // patient nhi
        this.nhiSelector = 'input[name="Patient[NHI]"]';
        this.bindEvents();
    }

    /**
     * Set the url to be used for lookup requests.
     *
     * @param {string} url The url to use.
     * @returns {PatientFields}
     */
    setLookupUrl(url) {
        this.lookupUrl = url;
        return this;
    }

    bindEvents() {
        // lookup patient by NHI number
        $(this.nhiSelector).attr('autocomplete', 'off').typeahead({
            source: (query, callback) => this.searchPatient(query, callback),
            afterSelect: (item) => this.selectPatient(item)
        });
    }

    /**
     * Makes ajax call to server to get a list of matching patients, used to autopopulate patient details.
     *
     * Called by typeahead plugin.
     *
     * @param {string} query Current query.
     * @param {function} callback Callback for typeahead.
     * @returns {Promise}
     */
    searchPatient(query, callback) {
        let params = {nhi: query},
            minLength = 3;

        // if nhi is less than minLength, return empty response
        if (query.length < minLength) {
            callback([]);
            return;
        }

        return $.get(this.lookupUrl, params, (response) => {
            callback(response);
        });
    }

    /**
     * Called by typeahead when use selects a consultant results.
     *
     * Updated for fields with consultant values.
     *
     * @param {Object} item
     */
    selectPatient(item) {
        this.childElements('input[name="Patient[FirstName]"]').val(item.FirstName);
        this.childElements('input[name="Patient[LastName]"]').val(item.LastName);
        this.childElements('input[name="Patient[MiddleName]"]').val(item.MiddleName);
        this.childElements('input[name="Patient[DateOfBirth]"]').val(item.DateOfBirth);
        this.childElements('input[name="Patient[NHI]"]').val(item.NHI);
        this.childElements('select[name="Patient[Gender]"]').val(item.Gender);
    }
}
